import styled, { keyframes } from 'styled-components';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const LoadingSpinner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(0, 0, 0, 0.5);

  &:after {
    content: '';
    display: block;
    width: 50px;
    height: 50px;

    animation: ${rotate360} 2s linear infinite;

    background-image: url('/images/icons/loading-spinner.svg');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

export const RelativeLoadingSpinner = styled.div`
  height: 500px;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  &:after {
    content: '';
    display: block;
    width: 100px;
    height: 100px;

    animation: ${rotate360} 2s linear infinite;

    background-image: url('/images/icons/loading-spinner-alt.svg');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/LoadingSpinner.js